<template>
  <div class="portfolios-content">
    <Heading :level="3" class="portfolios-content__title">
      Minhas Carteiras
    </Heading>
    <div v-if="isFetching">
      <SkeletonLoader class="portfolios-content__loader">
        <div class="portfolios-content__loader__item" />
      </SkeletonLoader>
    </div>
    <HelperViewStatus
      v-else-if="isFetchFailed"
      class="portfolios-content__error"
      generic-error
      button-label="Tentar novamente"
      @click="fetchUserPortfolios"
    />
    <BaseText
      v-else-if="portfolios.length === 0"
      class="portfolios-content__label-empty"
    >
      Você ainda não tem uma carteira
    </BaseText>
    <section v-else class="portfolios-content__list">
      <div
        v-for="(portfolio, index) in portfolios"
        :key="index"
        data-testid="emit-event-tracking"
        @click="trackViewPortfolio(portfolio.name)"
      >
        <router-link :to="getLocation(portfolio)">
          <PortfolioCardV2 :portfolio="portfolio" />
        </router-link>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';

import {
  Heading,
  BaseText,
  SkeletonLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { PortfolioCardV2 } from '@/modules/wealth/components/PortfolioCardV2';
import { PortfolioCategories } from '@/types/models';
import { IPortfolioList } from '@/types/models/Portfolio';
import { trackViewPortfolio } from './track-events';
import { PortfolioModule } from '@/store/modules/PortfolioModule';

const isFetching = computed(() => PortfolioModule.isFetching);
const isFetchFailed = computed(() => PortfolioModule.isFetchFailed);
const portfolios = computed(() => PortfolioModule.portfolios);

function fetchUserPortfolios() {
  PortfolioModule.fetchPortfolios();
}

const getLocation = (portfolio: IPortfolioList) => {
  if (portfolio.type === PortfolioCategories.VariableIncome) {
    return {
      name: 'wealthIndexPortfolio',
      params: { portfolioId: portfolio.id }
    };
  } else {
    return {
      name: 'wealthPortfolio',
      params: { id: portfolio.id, type: portfolio.type }
    };
  }
};

onMounted(() => {
  fetchUserPortfolios();
});
</script>

<style lang="less" scoped>
.portfolios-content {
  &__title {
    padding-bottom: @size-spacing-x300;
  }

  &__loader {
    &__item {
      width: 100%;
      height: 240px;
      border-radius: @size-radius-x400;
    }
  }

  &__label-empty {
    margin-bottom: @size-spacing-x450;
    padding-top: @size-spacing-x450;
    border-top: @size-border-x400 solid @divider-primary;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x400;
  }
}
</style>
